<div class="responsive-navbar">
  <div class="responsive-navbar__header" matLine>
    <h3 class="responsive-navbar__brand">
      <a (click)="getPageToRedirect()" aria-label="ClinDx">
        <img class="responsive-navbar__brand__logo" src="{{cdnImageUrl}}LabPort_logo_small.png" alt="ClinDx">
      </a>
    </h3>
    <mat-nav-list>
      <mat-list-item>
        <mat-icon mat-list-icon>account_circle</mat-icon>
        <div mat-line>
          <span class="whitespace-normal">{{getUserName()}}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
    </mat-nav-list>
  </div>
  <div class="responsive-navbar__menu">
    <mat-nav-list>
      <a mat-list-item routerLink="/home" routerLinkActive="list-item-active" tabindex="-1"
      (click)="accordion.closeAll()">Home</a>
@if (orderCheck()) {
  <div>
          @if (hasCanPlaceOrdersPermission) {
            <mat-accordion class="expantion-panel" #OrderSection multi>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Order
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-panel-description>
                  <mat-nav-list class="width100">
                    <!-- Place New Order -->
                    <a mat-list-item
                    routerLink="/order/create-order" routerLinkActive="list-item-active" [routerLinkActiveOptions]="{exact:true}">Place New Order</a>
                    
                    <!-- View Orders -->
                    <a mat-list-item
                    routerLink="/order" routerLinkActive="list-item-active" [routerLinkActiveOptions]="{exact:true}">View Orders</a>
                    
                    <!-- View Standing Orders (only for TGI BU users) -->
                    @if (isTgiBu) {
                      <a mat-list-item
                      routerLink="/order" [queryParams]="{viewType: 'standing'}" routerLinkActive="list-item-active" [routerLinkActiveOptions]="{exact:true}">View Standing Orders</a>
                    }
                  </mat-nav-list>
                </mat-panel-description>
              </mat-expansion-panel>
            </mat-accordion>
          }
          @if (isAuthorizedService.checkControlAuthorization('subTabManagePackages')) {
            <mat-accordion class="expantion-panel" #OrderSection multi
            >
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Order
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-panel-description>
                  <mat-nav-list class="width100">
                    @if (isAuthorizedService.checkControlAuthorization('subTabOrders')) {
                      <a mat-list-item
                      routerLink="/order" routerLinkActive="list-item-active" [routerLinkActiveOptions]="{exact:true}">Order List</a>
                    }
                    @if (hasInputPocPermission) {
                      <a mat-list-item
                      routerLink="/order/input-point-of-care" routerLinkActive="list-item-active" [routerLinkActiveOptions]="{exact:true}">Input point Of Care</a>
                    }
                    @if (isAuthorizedService.checkControlAuthorization('subTabPurchaseOrder')) {
                      <a mat-list-item
                      routerLink="/order/purchase-order" routerLinkActive="list-item-active" [routerLinkActiveOptions]="{exact:true}">Purchase Orders</a>
                    }
                    @if (isAuthorizedService.checkControlAuthorization('subTabManagePackages')) {
                      <a mat-list-item
                      routerLink="/order/manage-packages" routerLinkActive="list-item-active" [routerLinkActiveOptions]="{exact:true}">Manage Packages</a>
                    }
                    @if (isAuthorizedService.checkControlAuthorization('subTabCreateBulkOrders')) {
                      <a mat-list-item
                      routerLink="/order/create-bulk-order" routerLinkActive="list-item-active" [routerLinkActiveOptions]="{exact:true}">Bulk Upload Orders</a>
                    }
                    @if (isAuthorizedService.checkControlAuthorization('subTabManagePackages')) {
                      <a mat-list-item
                      routerLink="/order/order-tracker" routerLinkActive="list-item-active" [routerLinkActiveOptions]="{exact:true}">Order Tracker</a>
                    }
                    @if (hasPendingApprovalPermission) {
                      <a mat-list-item
                      routerLink="/order/pending-approvals" routerLinkActive="list-item-active" [routerLinkActiveOptions]="{exact:true}">Pending Approvals</a>
                    }
                  </mat-nav-list>
                </mat-panel-description>
              </mat-expansion-panel>
            </mat-accordion>
          }
        </div>
      }
      @if (isAuthorizedService.checkControlAuthorization('subTabResult')) {
        <a mat-list-item routerLink="/results"
        routerLinkActive="list-item-active" tabindex="-1" (click)="accordion.closeAll()">Results</a>
      }
      @if (isAuthorizedService.checkControlAuthorization('subTabManagePatients')) {
        <a mat-list-item routerLink="/patient-list"
        routerLinkActive="list-item-active">Patient</a>
      }
      @if (isAuthorizedService.checkControlAuthorization('subTabManageLabConfiguration') || isAuthorizedService.checkControlAuthorization('subTabManageProjects') ||
        isAuthorizedService.checkControlAuthorization('subTabAnnouncements')||isAuthorizedService.checkControlAuthorization('subTabManageInternalUser')||
        isAuthorizedService.checkControlAuthorization('subTabManageUser')||isAuthorizedService.checkControlAuthorization('subTabManagePatients')) {
        <mat-accordion multi class="expantion-panel"
          >
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Configuration
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-panel-description>
              <mat-nav-list class="width100">
                @if (isAuthorizedService.checkControlAuthorization('subTabManageProjects')) {
                  <a mat-list-item
                    routerLink="/manage-projects" routerLinkActive="list-item-active" tabindex="-1"
                  (click)="accordion.closeAll()">Projects</a>
                }
                @if (isAuthorizedService.checkControlAuthorization('subTabAnnouncements')) {
                  <a mat-list-item
                  routerLink="/announcements" routerLinkActive="list-item-active" tabindex="-1">Announcements</a>
                }
                @if (isAuthorizedService.checkControlAuthorization('subTabManagePackages')) {
                  <a mat-list-item
                  routerLink="/register-labels" routerLinkActive="list-item-active" tabindex="-1">Register Labels</a>
                }
              </mat-nav-list>
            </mat-panel-description>
            @if (isAuthorizedService.checkControlAuthorization('subTabManageLabConfiguration') || isAuthorizedService.checkControlAuthorization('subTabManageLabConfiguration')
              ||isAuthorizedService.checkControlAuthorization('subTabManageLabConfiguration')||isAuthorizedService.checkControlAuthorization('subTabManageLabConfiguration')) {
              <mat-accordion
                >
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Lab Configuration
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-panel-description>
                    <mat-nav-list class="width100">
                      @if (isAuthorizedService.checkControlAuthorization('subTabManageLabConfiguration')) {
                        <a mat-list-item
                        routerLink="/questions" routerLinkActive="list-item-active">Questions</a>
                      }
                      @if (isAuthorizedService.checkControlAuthorization('subTabManageLabConfiguration')) {
                        <a mat-list-item
                        routerLink="/tests" routerLinkActive="list-item-active">Tests/Panels</a>
                      }
                      @if (isAuthorizedService.checkControlAuthorization('subTabManageLabConfiguration')) {
                        <a mat-list-item
                        routerLink="/payors" routerLinkActive="list-item-active">Payors</a>
                      }
                    </mat-nav-list>
                  </mat-panel-description>
                </mat-expansion-panel>
              </mat-accordion>
            }
            @if (isAuthorizedService.checkControlAuthorization('subTabManageInternalUser') || isAuthorizedService.checkControlAuthorization('subTabManageUser')) {
              <mat-accordion
                >
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Users
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-panel-description>
                    <mat-nav-list class="width100">
                      @if (isAuthorizedService.checkControlAuthorization('subTabManageInternalUser')) {
                        <a mat-list-item
                          routerLink="/manage-internal-users" routerLinkActive="list-item-active" tabindex="-1"
                        (click)="accordion.closeAll()">Internal Users</a>
                      }
                      @if (isAuthorizedService.checkControlAuthorization('subTabManageUser')) {
                        <a mat-list-item
                          routerLink="/manage-customer-users" routerLinkActive="list-item-active" tabindex="-1"
                        (click)="accordion.closeAll()">Customer Users</a>
                      }
                    </mat-nav-list>
                  </mat-panel-description>
                </mat-expansion-panel>
              </mat-accordion>
            }
            <mat-panel-description>
              <mat-nav-list class="width100">
                @if (isAuthorizedService.checkControlAuthorization('subTabViewAuditLogs')) {
                  <a mat-list-item
                    routerLink="/user-activity-log" routerLinkActive="list-item-active"
                  (click)="accordion.closeAll()">User Activity Log</a>
                }
              </mat-nav-list>
            </mat-panel-description>
            <mat-panel-description>
              <mat-nav-list class="width100">
                @if (isAuthorizedService.checkControlAuthorization('subTabManageAccounts')) {
                  <a mat-list-item
                    routerLink="/manage-accounts" routerLinkActive="list-item-active" tabindex="-1"
                  (click)="accordion.closeAll()">Accounts</a>
                }
              </mat-nav-list>
            </mat-panel-description>
          </mat-expansion-panel>
        </mat-accordion>
      }
    </mat-nav-list>
  </div>
</div>
